export const environment = {
  production: false,

  BENEFICIARY_GROUP_CODE: 'CIV001',

  ADYEN_CLIENT_KEY: 'test_LNGR7WXYPBGT7EQBZ2Y5GPVD64MESDJN',
  ADYEN_ENV: 'test',
  ADYEN_FACADE_URL: '  https://kampala.100weeks.org/adyen/payments/adyen',
  ADYEN_RETURN_URL: '',

  DEV_TEST_QA_adyenPublicKey: '10001|A023E2DE2896A18C0C0356CA6632C964869DB25EF4ED02BD7F83661DCDD1310DD2A8C8FCBF91854946EEE4CCB0F8A2CCAF2AEAEA0D315DA6BDE6460FD9769D21E16391A7C5B4D7FEF8E5A3C6F45377548FEA95AF1FEEB41D894749EEF5484435A97F800C1C1C112C66779D7D5121FD38377BF91C2E9A0752171A1B0C1279FB11A821C2DD352835BB84E7504012A27BAAF780DDDE59DD0A24BA41568BCEB5FFAC7417A982E6C9100C53A568765F36F26A0C64D81612271CA52DB47E2CE46912ADF8AB2563FAD21EBCBD68AFDB40385BE02A4FBDCD8E9AADB3AC7ABC858463379ABC311CE04A12842A9E73782F88BFCFCBAD89675BA6BF58EEB217B16C0A12982F',
  PROD_adyenPublicKey: '10001|F5D40599DFBC7141A9C0CEC2AC212C2470E122F9989880B0C38283F0324CEFF6FB68EAAEB8001AB81095A0645E2D1AE420162690124696FA18FD6691060B9090B9272EE338A12E62D4A9198D20F79A0B9E4DE9CCFE487643A0B017404CE9E6C641903118FC2C6D30B4B8FC6F27BED36F014D14458A0BC7ACF2AD39D1DB215B983E68B08B93D1CFB9AC6CF76F8088216C89ACA2923FF7AE6BA1EA3C18029AF4C925C99E24D6AD360AA76A8D31905B91FB88EABA8077733C8F95F47827368375046BB1A4FF69E684736B504453BCC8BE08906CFF5D37A6DD89F005851B02313C5A9C67903003A4B71A49C97E8897452CF8FE52FB11CCCF54C29907DCE9D6402D6F',

  DEV_TEST_gaTrackingID: 'UA-93780528-2',
  PROD_gaTrackingID: 'UA-93780528-1',
  PROD_ORG_gaTrackingID: 'UA-93780528-3',
};
